import styled from 'styled-components'
import { Checkbox } from 'antd'

export const MyCheckbox = styled(Checkbox)<{
  $dark?: boolean
}>`
  color: ${props =>
    props.$dark ? props.theme['neutral-400'] : props.theme['neutral-100']};
  .ant-checkbox-inner {
    border-radius: 50%;
    width: 16px;
    height: 16px;
    border-width: 2px;
    border-color: ${props =>
      props.$dark ? props.theme['neutral-400'] : props.theme['neutral-600']};
    background: ${props => (props.$dark ? 'none' : '#fff')};
    &:after {
      left: 20%;
      width: 5px;
      height: 9px;
      border-color: var(--neutral-100);
    }
  }
  .ant-checkbox {
    &:hover {
      .ant-checkbox-inner {
        border-radius: 50%;
      }
    }
  }

  .ant-checkbox-checked {
    .ant-checkbox-inner {
      border-color: ${props => props.theme.primary};
      background: ${props => props.theme.primary};
    }
    &:after {
      border: none;
    }
  }
`
